<template>
    <div class="newest">
      <div class="content">
          <div class="title">
            <h2>
                <slot 
									name="title">
								</slot>
            </h2>
            <p>
							<slot 
									name="subtitle">
								</slot>
						</p>

          </div>
          <div class="popular-items-wrapper">
            <VueSlickCarousel :arrows="true" :dots="true" v-if="this.meals.length > 4" v-bind="settings">
                <div class="popular-item" v-for="(meal, index) in meals" :key="index">
                    <div class="meal-image" v-if="meal.image">
                        <img :src="meal.image.path">
                    </div>
                    <h3>{{ meal.name }}</h3>
                    <p class="description">{{ meal.description }}</p>
                      <span v-if="$props.isBrunch == true" class="price">{{ meal.price_brunch }}€</span>
                     <span v-else class="price">{{ meal.price }}€</span>
                     
                </div>
            </VueSlickCarousel>
            <div v-else class="items-wrapper-no-slick">
                <div class="popular-item-no-slick" v-for="(meal, index) in meals" :key="index">
                    <div class="meal-image" v-if="meal.image">
                        <img :src="meal.image.path">
                    </div>
                    <h3>{{ meal.name }}</h3>
                    <p class="description">{{ meal.description }}</p>
                    <span v-if="$props.isBrunch == true" class="price">{{ meal.price_brunch }}€</span>
                     <span v-else class="price">{{ meal.price }}€</span>
                </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    data: () => ({
        settings: {
            "arrows": true,
            "dots": true,
            "dotsClass": "slick-dots custom-dot-class",
            "edgeFriction": 0.35,
            "infinite": false,
            "speed": 500,
            "slidesToShow": 4,
            "slidesToScroll": 1,
            "responsive": [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },

            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 639,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            ]
        }
    }),
    props: ['meals', 'isBrunch'],
    components: {
        VueSlickCarousel
    },
    
};
</script>

<style lang="scss">   
@import 'meals.scss'
</style>